export function toIsoDate(value: string | Date) {
  if (value instanceof Date) {
    value = value.toISOString();
  }

  return value.substring(0, 10);
}
